import { Col, Row, Typography } from 'antd';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import ErrorBoundary from '../components/ErrorBoundary';
import Whitespace from '../components/Whitespace';
import { FAIcon } from '../components/adapters/fontAwesomeAdapters';
import { InlineLink } from '../components/typography';
import { cssVariables } from '../styles/cssVariables';
import { pxToNumber } from '../utils/cssUtils';
import { useDetailPageHeadersStyles } from './detailPageHeaders.styles';

function SimpleDetailPageHeader({ className, children }) {
  const { styles } = useDetailPageHeadersStyles();
  return (
    <ErrorBoundary>
      <div className={classNames(styles.detailPageHeader, className)}>
        {children}
      </div>
    </ErrorBoundary>
  );
}

export function BackLinkDetailPageHeader({
  backTargetId,
  backLink,
  titleId,
  buttons,
}) {
  const { styles } = useDetailPageHeadersStyles();
  return (
    <SimpleDetailPageHeader
      className={classNames(
        styles.detailPageHeaderSize40,
        styles.detailPageHeaderWithBackLink
      )}
    >
      <Row className="flex-nowrap" align="middle" justify="space-between">
        <Col>
          {backLink && backTargetId && (
            <InlineLink
              iconBefore={<FAIcon icon="arrow-circle-left" />}
              to={backLink}
            >
              <FormattedMessage id="buttons.prefix.backTo" />
              <Whitespace />
              <FormattedMessage id={backTargetId} />
            </InlineLink>
          )}
        </Col>
        <Col>
          <Row
            className="flex-nowrap"
            align="middle"
            gutter={pxToNumber(cssVariables.spaceNorm)}
          >
            <Col>
              <Typography.Title level={2}>
                <FormattedMessage id={titleId} />
              </Typography.Title>
            </Col>
            {buttons && <Col>{buttons}</Col>}
          </Row>
        </Col>
      </Row>
    </SimpleDetailPageHeader>
  );
}
